import React from 'react';
import { DRAW_TOOL_KEY, DRAW_TOOL_LABEL, type ArmedTool } from './armedTool';
import './draw-tool-label.css';

/**
 * A draw tool's label with its first letter capped as the key that presses it. The
 * toolbar's draw buttons and the kind pill both render it, so the two read alike.
 * It is one flex item, so a button recipe's gap does not split the cap from its word.
 */
const DrawToolLabel: React.FC<{ tool: ArmedTool }> = ({ tool }) => (
  <span><kbd className="pnid-ws-draw-key">{DRAW_TOOL_KEY[tool]}</kbd>{DRAW_TOOL_LABEL[tool].slice(1)}</span>
);

export default DrawToolLabel;
